import * as React from "react";
import type { SVGProps } from "react";
const SvgSquareArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 3.9a.9.9 0 0 1 .9-.9h8.486a.9.9 0 1 1 0 1.8H4.8v14.4h14.4v-7.586a.9.9 0 1 1 1.8 0V20.1a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V3.9Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.746 7.722c-.184.184-.432.29-.707.297a.996.996 0 0 1-.998-.997l-.003-1.608-7.332 7.332a1.003 1.003 0 0 1-1.414 0 1.003 1.003 0 0 1 0-1.415L18.624 4l-1.609-.004a.996.996 0 1 1 0-1.994h3.964a.998.998 0 0 1 1.05 1.13v3.883a.982.982 0 0 1-.297.707h.014Z"
    />
  </svg>
);
export default SvgSquareArrowUpRight;
